import styled from 'styled-components';

import { styledLayout, styledReset } from '@pkg/primitives';

import { tokens } from './tokens';

export const StyledThumbnailStack = styled.div`
    ${styledReset.borderBox};
    position: relative;
`;

export const PresentContainer = styled.div`
    position: relative;
    z-index: ${tokens.zindex.present};
`;

export const LeavingContainer = styled.div`
    ${styledLayout.positionCover()};
    z-index: ${tokens.zindex.leaving};
    pointer-events: none;
`;

export const List = styled.ol`
    ${styledReset.list};
    display: grid;
    grid-template-columns: repeat(auto-fill, ${tokens.item.offset}px);
    gap: ${tokens.item.offset}px;
    align-content: center;
    align-items: center;
    width: ${tokens.list.width}px;
    height: ${tokens.list.height}px;
`;
